import { LuLink, LuRefreshCw } from 'react-icons/lu';

import { CalendarIcon } from '../../../components/Icons';
import { Button } from '../../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { useConnectCalendar } from '../calendar-queries';

export const ConnectCalendarCard = () => {
    const connectCalendar = useConnectCalendar();
    const handleConnect = () => {
        connectCalendar.mutateAsync();
    };

    return (
        <Card className="">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <CalendarIcon className="h-5 w-5" />
                    Calendar Integration
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div>
                    <span className="text-muted-foreground text-sm">
                        Connect your Calendar to view and sync your events.
                    </span>

                    <div className="flex gap-2 pt-6">
                        <Button
                            onClick={handleConnect}
                            disabled={connectCalendar.isPending}
                            className="flex items-center gap-2"
                        >
                            {connectCalendar.isPending ? (
                                <LuRefreshCw className="h-4 w-4 animate-spin" />
                            ) : (
                                <LuLink className="h-4 w-4" />
                            )}
                            Connect Calendar
                        </Button>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};
